import Transfer from '../models/transfer.coffee'
import Upload from '../upload/upload.coffee'

class ObjectCache

  constructor: ->
    # TODO: We need some kind of weak-references to make sure the cache is deleted at some point
    @_items = {}

  getOrAddObject: (id, createFunc, updateFunc) ->
    if !item = @_items[id]
      @_items[id] = item = createFunc()
    else
      updateFunc item
    item

downloadCache = new ObjectCache()
uploadCache = new ObjectCache()

export default
  getOrCreateTransfer: (backendTransfer) ->
    # Obtain the identifier of the back-end transfer
    id = backendTransfer.createdAt        # TODO: Should be 'id'
    switch backendTransfer.transfer
      when 'upload'
        item = uploadCache.getOrAddObject id, (-> new Upload backendTransfer), ((transfer) -> transfer.update backendTransfer)
      when 'download'
        item = downloadCache.getOrAddObject id, (-> new Transfer backendTransfer), ((transfer) -> transfer.update backendTransfer)
    item

  addTransferToCache: (transfer) ->
    # Obtain the identifier of the transfer
    id = transfer.createdAt        # TODO: Should be 'id'
    switch backendTransfer.transfer
      when 'upload'
        item = uploadCache.getOrAddObject id, (-> transfer)
      when 'download'
        item = downloadCache.getOrAddObject id, (-> transfer)
